import { useState, useEffect } from 'react';
import { CreditCard, Smartphone, Building, Wallet, Plus, Trash2, RefreshCw, Star } from 'lucide-react';
import { PageShell, Modal, FG, INP, SEL, Row2, BtnPrimary, BtnGhost, BtnDanger, Spinner, useBanner, useWalletUser, EmptyState } from './WalletShared';
import walletController from '../../controllers/walletController';

const METHOD_ICONS = { card:CreditCard, upi:Smartphone, bank_transfer:Building, wallet:Wallet };

const PaymentMethods = () => {
  const { userId } = useWalletUser();
  const { banner, notify, clearBanner } = useBanner();
  const [methods,  setMethods]  = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [showAdd,  setShowAdd]  = useState(false);
  const [saving,   setSaving]   = useState(false);
  const [deleting, setDeleting] = useState(null);
  const [form,     setForm]     = useState({ type:'card', label:'', details:'' });

  const load = async () => {
    setLoading(true);
    const res = await walletController.getPaymentMethods(userId);
    if (res.success) setMethods(res.data);
    else notify('error', res.message);
    setLoading(false);
  };
  useEffect(() => { load(); }, [userId]);

  const handleAdd = async () => {
    if (!form.label) return notify('error','Label is required');
    setSaving(true);
    const res = await walletController.addPaymentMethod(userId, form);
    setSaving(false);
    if (res.success) { notify('success', res.message); setShowAdd(false); setForm({ type:'card', label:'', details:'' }); load(); }
    else notify('error', res.message);
  };

  const handleDelete = async (id) => {
    setDeleting(id);
    const res = await walletController.deletePaymentMethod(userId, id);
    setDeleting(null);
    if (res.success) { notify('success', res.message); load(); }
    else notify('error', res.message);
  };

  return (
    <PageShell title="Payment Methods" subtitle="Manage your payment options" icon={CreditCard}
      banner={banner} onCloseBanner={clearBanner}
      actions={<button onClick={() => setShowAdd(true)} style={{ display:'flex', alignItems:'center', gap:5, padding:'7px 14px', background:'#1e293b', color:'#fff', border:'none', borderRadius:8, fontSize:12, fontWeight:600, cursor:'pointer' }}><Plus size={14}/>Add Method</button>}>

      {loading
        ? <div style={{ display:'flex', justifyContent:'center', padding:'50px 0', gap:10, color:'#64748b' }}><Spinner size={24}/><span>Loading…</span></div>
        : methods.length===0
          ? <EmptyState icon={CreditCard} message="No payment methods added yet"
              action={<button onClick={() => setShowAdd(true)} style={{ padding:'8px 18px', background:'#1e293b', color:'#fff', border:'none', borderRadius:8, fontSize:13, cursor:'pointer' }}>Add Payment Method</button>}/>
          : (
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))', gap:14 }}>
              {methods.map(m => {
                const Icon = METHOD_ICONS[m.type] || CreditCard;
                return (
                  <div key={m._id} style={{ background:'#fff', borderRadius:12, border:'1px solid #f1f5f9', padding:'16px 18px', display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                      <div style={{ width:40, height:40, borderRadius:10, background:'#eff6ff', display:'flex', alignItems:'center', justifyContent:'center' }}>
                        <Icon size={18} color="#3b82f6"/>
                      </div>
                      <div>
                        <div style={{ fontSize:13, fontWeight:600, color:'#1e293b' }}>{m.label}</div>
                        <div style={{ fontSize:11, color:'#94a3b8', textTransform:'capitalize' }}>{m.type?.replace('_',' ')}</div>
                        {m.isDefault && <span style={{ fontSize:10, background:'#dbeafe', color:'#1d4ed8', padding:'1px 6px', borderRadius:4, fontWeight:600 }}>Default</span>}
                      </div>
                    </div>
                    <button onClick={() => handleDelete(m._id)} disabled={deleting===m._id}
                      style={{ background:'none', border:'none', cursor:'pointer', color:'#94a3b8', padding:4 }}>
                      {deleting===m._id ? <Spinner size={14}/> : <Trash2 size={14}/>}
                    </button>
                  </div>
                );
              })}
            </div>
          )}

      {showAdd && (
        <Modal title="Add Payment Method" onClose={() => setShowAdd(false)}
          footer={<><BtnGhost onClick={() => setShowAdd(false)}>Cancel</BtnGhost><BtnPrimary onClick={handleAdd} disabled={saving}>{saving?<><Spinner size={13}/>Adding…</>:<><Plus size={13}/>Add</>}</BtnPrimary></>}>
          <FG label="Type *">
            <SEL value={form.type} onChange={e => setForm(p => ({ ...p, type:e.target.value }))}>
              <option value="card">Card</option>
              <option value="upi">UPI</option>
              <option value="bank_transfer">Bank Transfer</option>
              <option value="wallet">Wallet</option>
            </SEL>
          </FG>
          <FG label="Label *"><INP value={form.label} onChange={e => setForm(p => ({ ...p, label:e.target.value }))} placeholder="e.g. My HDFC Card"/></FG>
          <FG label="Details"><INP value={form.details} onChange={e => setForm(p => ({ ...p, details:e.target.value }))} placeholder="Card/UPI/Account details"/></FG>
        </Modal>
      )}
    </PageShell>
  );
};
export default PaymentMethods;